export const hidden = {
    namespaced: true,
    state: {
        hidden_settings: {
            asr_version: "v1",
            wait_k: 1,
        },
    },
    actions: {
        setHiddenSettings({ commit }, settings) {
            commit('setHiddenSettings', settings);
            return Promise.resolve(settings);
        }
    },
    getters: {},
    mutations: {
        setHiddenSettings(state, settings) {
            state.hidden_settings = settings;
        },
    }
}